import React, { useContext, useEffect, useState } from 'react'
import { apiGet, apiDelete } from '../../utils/apiFetch' // Imported apiDelete
import apiPath from '../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import SalaryAdd from './SalaryAdd'
import SalaryEdit from './SalaryEdit'
import SalaryLists from './SalaryLists'
import SalaryView from './SalaryView'
import helpers from 'utils/helpers'
import OSearch from 'components/reusable/OSearch'
import useToastContext from 'hooks/useToastContext' // Imported Toast

const SalaryManager = () => {
  const { t } = useTranslation()
  const notification = useToastContext() // Initialized Toast
  const { user, updatePageName } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'subscription_manager') ?? {}
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)

  const [subscriptionView, setSubscriptionView] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [isDelete, setIsDelete] = useState(false)
  const [subscriptionAdd, setSubscriptionAdd] = useState(false)
  const [subscriptionEdit, setSubscriptionEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [subscriptionList, setSubscriptionList] = useState([])
  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
    category: '',
    searchKey: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setSubscriptionEdit(!subscriptionEdit)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleView = item => {
    setCurrentItem(item)
    setSubscriptionView(!subscriptionView)
  }

  const handleCategory = () => {
    setSubscriptionAdd(!subscriptionAdd)
  }

  // NEW: Handle Delete
  const handleDelete = async (item) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this employee salary record?");
    if (!isConfirmed) return;

    try {
      const path = `${apiPath.deleteEmployeeSalary}/${item?._id}`;
      const result = await apiDelete(path);
      
      if (result?.data?.success) {
        notification.success(result.data.message || "Deleted successfully");
        allSubscription({ deletePage: true }); // Refresh list and handle pagination
      } else {
        notification.error(result?.data?.message || "Failed to delete");
      }
    } catch (error) {
      console.log("error deleting salary:", error);
      notification.error(error.message || "Something went wrong");
    }
  };

  const allSubscription = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && subscriptionList?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          subscriptionList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }
      const payload = {
        page,
        pageSize,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        status: category,
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }

      const path = apiPath.manageSalaryList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setSubscriptionList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all subscription list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allSubscription()
  }, [filterData, sort, page])

  const handleReset = () => {
    setFilterData({
      isReset: true,
      isFilter: false,
      category: '',
      searchKey: '',
      startDate: '',
      endDate: ''
    })
    setPage(1)
    setIsDelete(true)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
    setIsDelete(true)
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName('Manage Salary')
  }, [])
  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <div className='relative flex items-center mb-3'>
                    <OSearch
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      placeholder={t('SEARCH_BY_NAME_ID')}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <OButton
                    label='Reset'
                    type='button'
                    onClick={handleReset}
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                  />
                </div>
              </div>
              <div className='flex items-center justify-end px-4 ms-auto mb-3'>
                <button
                  title='Add subscription'
                  type='button'
                  className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                  onClick={() => handleCategory()}
                >
                  + Create Salary
                </button>
              </div>
            </form>
            
            {/* Passed handleDelete to SalaryLists */}
            <SalaryLists
              subscriptionList={subscriptionList}
              page={page}
              allSubscription={allSubscription}
              handleEdit={handleEdit}
              handleView={handleView}
              handleDelete={handleDelete} 
              currentItem={currentItem}
              subscriptionView={subscriptionView}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />
            
            {subscriptionView && (
              <SalaryView
                subscriptionView={subscriptionView}
                currentItem={currentItem}
                handleView={handleView}
                allSubscription={allSubscription}
              />
            )}
            {subscriptionEdit && (
              <SalaryEdit
                allSubscription={allSubscription}
                handleEdit={handleEdit}
                currentItem={currentItem}
                SalaryList={SalaryLists}
              />
            )}
            {subscriptionAdd && (
              <SalaryAdd
                subscriptionAdd={subscriptionAdd}
                allSubscription={allSubscription}
                handleCategory={handleCategory}
                subscriptionList={subscriptionList}
              />
            )}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                isDelete={isDelete}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default SalaryManager